/* from VS template
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import * as Counter from './Counter';
import * as WeatherForecasts from './WeatherForecasts';

export default function configureStore(history, initialState) {
  const reducers = {
    counter: Counter.reducer,
    weatherForecasts: WeatherForecasts.reducer
  };

  const middleware = [
    thunk,
    routerMiddleware(history)
  ];

  // In development, use the browser's Redux dev tools extension if installed
  const enhancers = [];
  const isDevelopment = process.env.NODE_ENV === 'development';
  if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension) {
    enhancers.push(window.devToolsExtension());
  }

  const rootReducer = combineReducers({
    ...reducers,
    routing: routerReducer
  });

  return createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
}
*/


import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
//import { composeWithDevTools } from 'redux-devtools-extension';
//import { forbiddenWordsMiddleware } from "../middleware";

import reducers from "../reducers/reducers";

const storeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducers,
  storeEnhancers(applyMiddleware(/*forbiddenWordsMiddleware, */thunk))
);

//const composeEnhancers = composeWithDevTools({
//  // Specify custom devTools options
//});
//const store = createStore(reducers, /* preloadedState, */ composeEnhancers(
//  applyMiddleware(thunk),
//));

export default store;


// WEBPACK FOOTER //
// ./src/store/configureStore.js